import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../../services/employee.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AnalyticsService } from '../../services/analytics.service';
import { menurolesService } from '../../services/menuroles.service';

@Component({
  selector: 'app-firstavailable-doctors',
  templateUrl: './firstavailable-doctors.component.html',
  styleUrls: ['./firstavailable-doctors.component.scss']
})
export class FirstavailableDoctorsComponent implements OnInit {
  isPageEditable: boolean = false;
  public isSlide: boolean = false;
  selectedview: number;
  employees: Observable<any>;
  employee: Observable<any>;
  selectedDoctor: Observable<any>;
  statusMessage: string = "Loading data please wait...";
  constructor(private _employeeService: EmployeeService, private router: Router, private _analyticsService: AnalyticsService, private _menurolesService: menurolesService) { }
  ngOnInit() {
    this.isPageEditable = false;
    this.isPageEditable = this._menurolesService.getpageAcessbility()
    this.getDoctorList();
  }

  getDoctorList() {
    this._employeeService.getFirstAvailableDoctors()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.employees = employeeData.response.doctotList
          }
          console.log(this.employees);
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        });
  }


  addFirstAvailableDoctor(emp) {
    let confimationMessage = emp.isFirstAvailable == false ? "Are you sure want to Add First available " + emp.name : "Are you want to Remove first " + emp.name;
    if (confirm(confimationMessage)) {
      this._employeeService.saveFirstAvailableDoctor(emp).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Record updated sucessfully")
            this.getDoctorList();
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          alert(error)
          console.log(error)
        });

    }
    else {
      this.getDoctorList();
    }
  }

  assignGroupADoctor(emp) {
    if (emp.isFirstAvailable == false) {
      alert("please add " + emp.name + " First Available Doctor list before add / Remove into Group A Doctor")
      emp.isFromGroupADoctor == false;
      var selectedItem = this.employees
      this.getDoctorList();
      return
    }
    else {
      let confimationMessage = emp.isFromGroupADoctor == true ? "Are you sure want to Remove " + emp.name + " from Group A Doctor" : "Are you want to Add " + emp.name + " in to Group A Doctors";
      if (confirm(confimationMessage)) {
        this._employeeService.savegroupaDoctor(emp).subscribe(
          data => {
            if (data.returnCode == 0) {
              alert("Record updated sucessfully")
              this.getDoctorList();
            }
            else {
              alert(data.returnMsg)

            }
          },
          error => {
            // this.alertService.error(error);
            // this.loading = false;         
            alert(error)
            console.log(error)
          });

      }
      else {
        this.getDoctorList();
      }
    }

  }

  updateEmployeeStatus(emp) {
    let confimationMessage = emp.doctorAvailability == true ? "Are you sure want to Logout " + emp.name : "Are you sure want to make " + emp.name + " available";

    if (confirm(confimationMessage)) {
      console.log("Implement delete functionality here");
      this._employeeService.updateEmployeeloginStatus(emp).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Record updated sucessfully")
            this.getDoctorList();
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          alert(error)
          console.log(error)
        });

    }
  }

  onSearchChange(obj) {
    console.log(obj)
  }

  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/admin/firstavailable-doctors/firstavailable-doctors.component.ts